import { useRecoilValue } from "recoil";

import { useFeatureGates } from "../../cof-feature-gates/hooks";
import { organizationsInitializedState } from "../../core/recoil/organizations";
import { CofConfigId } from "../../gql-generated/types";

import { useOrganizationsV2Initialized } from "./useOrganizationsV2";

export const useIsInitialized = (): boolean => {
    const { configs } = useFeatureGates();
    const isMyLensesOrgsV2Enabled = configs[CofConfigId.MyLensesOrgsV2].enabled;

    const isInitializedV1 = useRecoilValue(organizationsInitializedState);
    const isInitializedV2 = useOrganizationsV2Initialized();

    return isMyLensesOrgsV2Enabled ? isInitializedV2 : isInitializedV1;
};
